/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Create a public API to a decorator for the n-th vipr dataset
 *
 * @class DecoratorAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec){

				const drillGetUndoActions =  () => {
					let actionName;
					let params;
					const drillDown = this.getDrillDownValue();
					const drillUp  = this.getDrillUpValue();
					if (!drillDown && !drillUp){
						actionName = 'clearDrill';
						params = [];
					} else if (drillDown){
						actionName =  'drillDown';
						params = [drillDown];
					} else if (drillUp){
						actionName = 'drillUp';
						params = [drillUp];
					}
					return [{
						name: actionName,
						params: params
					}];
				};

				this.apiSpec = {
					name:'dataitem API',
					features: {
						'Dashboard.Transaction': this.transaction
					},
					events:{
						serializeActions: {
							children:[{
								getObject: () => this.unionImpl,
								callStack:[{
									name:'getUnion',
									params:[]
								}]
							}]
						},
						propagationInfo: {
							namespace: this.isRootDataItem() ? 'dataitem': null,
							info: {
								dataItemId: this.getId()
							},
							callStack: {
								name:'getDataItem',
								params:[this.getId()]
							}
						},
						actions: {
							// This action is currently not exposed as a dataItem API . Will only be exposed when needed
							// setLabel: {
							// 	eventName:'label',
							// 	info:{
							// 		refresh: { render: true }
							// 	},
							// 	getUndoActions: () => [{ params:[this.dataItemModel.itemLabel] }]
							// },
							setAggregation: {
								eventName:'aggregation',
								getUndoActions: () => [{ params:[this.hasDefaultAggregation() ? undefined: this.getAggregation()] }],
								autoCreateTransaction: true,
								transactionParamIndex: 1,
								transactionAPI: this.transaction
							},
							setFormat: {
								eventName:'format',
								info:{
									refresh: { data:true } /* TODO: livewidget_cleanup - should not refresh data, but for some reason the data format change is not rendered properly without data refresh*/
								},
								getUndoActions: () => [{ params:[this.hasDefaultFormat() ? undefined: this.getFormat()] }]
							},
							setSort: {
								eventName:'sort',
								transactionParamIndex: 1,
								getUndoActions: () => [{ params:[this.hasDefaultSort() ? undefined: this.getSort()] }]
							},
							setTopBottom: {
								eventName:'topbottom',
								getUndoActions: () => [{ params:[this.getTopBottom()] }],
								autoCreateTransaction: true,
								transactionParamIndex: 1,
								transactionAPI: this.transaction
							},
							setBinning: {
								eventName:'binning',
								getUndoActions: () => [{ params:[this.getBinning()] }],
								autoCreateTransaction: true,
								transactionParamIndex: 1,
								transactionAPI: this.transaction
							},
							drillUp: {
								eventName:'drillUp',
								getUndoActions: drillGetUndoActions,
								autoCreateTransaction: true,
								transactionParamIndex: 1,
								transactionAPI: this.transaction
							},
							drillDown: {
								eventName:'drillDown',
								getUndoActions: drillGetUndoActions,
								autoCreateTransaction: true,
								transactionParamIndex: 1,
								transactionAPI: this.transaction
							},
							clearDrill: {
								eventName:'clearDrill',
								getUndoActions: drillGetUndoActions,
								autoCreateTransaction: true,
								transactionParamIndex: 0,
								transactionAPI: this.transaction
							}
						}
					}

				};
			}
			return this.apiSpec;

		}

	}

	return APISpec;
});
